(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-members-count-gutenberg-block', {

        // Block setup
        title: __('Discord Members Count', 'discord-wordpress-plugin'),
        description: __('Block outputs a number of members on your server.', 'discord-wordpress-plugin'),
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#da72cd" d="M246.818 98.5714C274.133 98.5714 296.017 76.5571 296.017 49.2857C296.017 22.0143 274.133 0 246.818 0C219.504 0 197.455 22.0143 197.455 49.2857C197.455 76.5571 219.504 98.5714 246.818 98.5714ZM115.182 98.5714C142.496 98.5714 164.381 76.5571 164.381 49.2857C164.381 22.0143 142.496 0 115.182 0C87.8673 0 65.8182 22.0143 65.8182 49.2857C65.8182 76.5571 87.8673 98.5714 115.182 98.5714ZM115.182 131.429C76.8427 131.429 0 150.65 0 188.929V230H230.364V188.929C230.364 150.65 153.521 131.429 115.182 131.429ZM246.818 131.429C242.046 131.429 236.616 131.757 230.857 132.25C249.945 146.05 263.273 164.614 263.273 188.929V230H362V188.929C362 150.65 285.157 131.429 246.818 131.429Z"/>
                <rect x="238" y="220" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            membersCount: {
                type: 'integer',
                default: 0,
            }
        },


        // Main editor function
        edit: props => {

            // Updating channels list
            if (!props.attributes.membersCount || props.attributes.membersCount === 0) {
                $.get( ajaxurl, { action: 'dwpp_getMembersCount' } )
                    .done( response => props.setAttributes( { membersCount: response.data.count ?? 100 } ) );

                return __('Loading...', 'discord-wordpress-plugin');
            }


            return props.attributes.membersCount;
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
